import React, { useState } from "react";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Autosuggest from "react-autosuggest";
import { Box, Flex, Text, Icon } from "samba-ui";
import Highlighter from "react-highlight-words";
import { selectAllFeeds } from "../../../selectors";
import "./theme.css";
import styled from "styled-components";

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 17px;
  left: 10px;
  width: 24px;
  height: 24px;
`;

const EllipsisBox = styled(Box)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100px;
`;

const StyledBox = styled(Box)`
  position: absolute;
  top: 50px;
  width: 517px;
`;

const searchOnKantarFilters = (feed, inputValue) => {
  let foundInfilters = false;
  const { kantar_filter_expression } = feed;
  if (!kantar_filter_expression || kantar_filter_expression.brand_blacklist) {
    return inputValue.toLowerCase() === "all brands";
  }
  Object.keys(kantar_filter_expression).forEach(k => {
    kantar_filter_expression[k] &&
      Array.isArray(kantar_filter_expression[k]) &&
      kantar_filter_expression[k].forEach(filter => {
        if (
          typeof filter === "string" &&
          filter.toLowerCase().indexOf(inputValue) > -1
        ) {
          foundInfilters = true;
        }
      });
  });

  return foundInfilters;
};

const filterFeed = (feed, inputValue) => {
  const inputLength = inputValue.length;
  return (
    feed.client_name.toLowerCase().slice(0, inputLength) === inputValue ||
    feed.name.toLowerCase().slice(0, inputLength) === inputValue ||
    feed.type.toLowerCase().slice(0, inputLength) === inputValue ||
    feed.country.toLowerCase().slice(0, inputLength) === inputValue ||
    feed.data_format.toLowerCase().slice(0, inputLength) === inputValue ||
    feed.user.toLowerCase().slice(0, inputLength) === inputValue ||
    searchOnKantarFilters(feed, inputValue)
  );
};

const FeedSearchbox = ({ feeds, history: { push } }) => {
  const [value, setValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [noSuggestions, setNoSuggestions] = useState(false);

  // Teach Autosuggest how to calculate suggestions for any given input value.
  const getSuggestions = value => {
    const inputValue = value.trim().toLowerCase();
    return !inputValue.length
      ? []
      : feeds.filter(feed => filterFeed(feed, inputValue));
  };

  // When suggestion is clicked, Autosuggest needs to populate the input
  // based on the clicked suggestion. Teach Autosuggest how to calculate the
  // input value for every given suggestion.
  const getSuggestionValue = suggestion => {
    push(`/clients/${suggestion.client_id}/feeds/${suggestion.id}`);
    return suggestion.name;
  };

  const renderInputComponent = inputProps => (
    <div className="inputContainer">
      <StyledIcon name="search" />
      <input {...inputProps} />
    </div>
  );

  // Use your imagination to render suggestions.
  const renderSuggestion = suggestion => {
    const renderedInfo = {
      client_name: 2 / 13,
      name: 3 / 13,
      type: 3 / 13,
      data_format: 1 / 13,
      country: 1 / 13,
      user: 3 / 13
    };

    return (
      <Flex
        alignItems="center"
        flexDirection="row"
        justifyContent="space-between"
        width="100%"
      >
        {Object.keys(renderedInfo).map(type => (
          <EllipsisBox key={type} width={renderedInfo[type]}>
            <Highlighter
              className="highlightable"
              highlightClassName="highlight"
              searchWords={[value]}
              textToHighlight={suggestion[type] || ""}
              autoEscape
            />
          </EllipsisBox>
        ))}
      </Flex>
    );
  };

  const onChange = (event, { newValue }) => {
    setValue(newValue);
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    const suggestions = getSuggestions(value);
    const isInputBlank = value.trim() === "";
    const noSuggestions = !isInputBlank && suggestions.length === 0;
    setSuggestions(suggestions);
    setNoSuggestions(noSuggestions);
  };

  const onSuggestionSelected = () => {
    setValue("");
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };
  const inputProps = {
    placeholder: "Search for a feed",
    value,
    onChange: onChange
  };

  return (
    <Box style={{ position: "relative" }}>
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        onSuggestionSelected={onSuggestionSelected}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
        renderInputComponent={renderInputComponent}
      />
      {noSuggestions && value && (
        <StyledBox
          p={4}
          border="1px solid"
          borderColor="rgb(170, 170, 170)"
          borderRadius="4px"
          borderTopLeftRadius="0px"
          borderTopRightRadius="0px"
          backgroundColor="white"
        >
          <Text fontSize={1} fontWeight={400}>
            No result found!
          </Text>
        </StyledBox>
      )}
    </Box>
  );
};

const mapStateToProps = state => ({
  feeds: selectAllFeeds(state)
});

const mapDispatchToProps = () => ({});

FeedSearchbox.propTypes = {
  feeds: PropTypes.array.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  })
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(FeedSearchbox)
);
